import Input from '../../common/Input';
import CheckBox from "../../common/CheckBox";

export const details = {

  id: 0,

  _system: {
    name: 'Details',
    relatedTo: 'details',
  },
  name: 'details',

  caption: {
    label: 'Caption',
    placeholder: 'Fill-in this field.',
    system: {
      component: Input,
      name: 'caption',
      relatedTo: 'details',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'caption',
    rules: {
      title: 'Caption field',
      required: true,
    }
  },
  description: {
    label: 'Description',
    placeholder: 'Fill-in this field.',
    system: {
      component: Input,
      name: 'content',
      relatedTo: 'details',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'description',
    rules: {
      title: 'Description field',
      required: true,
    }
  },
};

export const contacts = {

    id: 0,

    _system: {
      name: 'Contacts',
      relatedTo: 'contacts',
    },
    name: 'contacts',

    billing: {
      label: 'Set as "Billing"',
      placeholder: '',
      system: {
        component: CheckBox,
        name: 'billing',
        relatedTo: 'contacts',
      },
      value: false,
      errors: [],
      type: 'text',
      name: 'billing',
      rules: {
      }
    },
    shipping: {
      label: 'Set as "Shipping"',
      placeholder: '',
      system: {
        component: CheckBox,
        name: 'shipping',
        relatedTo: 'contacts',
      },
      value: false,
      errors: [],
      type: 'text',
      name: 'shipping',
      rules: {
      }
    },
    firstname: {
      label: 'First Name',
      placeholder: 'Fill-in this field.',
      system: {
        component: Input,
        name: 'firstname',
        relatedTo: 'contacts',
      },
      value: '',
      errors: [],
      type: 'text',
      name: 'firstname',
      rules: {
        title: 'First name field',
        required: true,
      }
    },
    lastname: {
      label: 'Last Name',
      placeholder: 'Fill-in this field.',
      system: {
        component: Input,
        name: 'lastname',
        relatedTo: 'contacts',
      },
      value: '',
      errors: [],
      type: 'text',
      name: 'lastname',
      rules: {
        title: 'Last name field',
        required: true,
      }
    },
    email: {
      label: 'Email',
      placeholder: 'Fill-in this field.',
      value: '',
      system: {
        component: Input,
        name: 'email',
        relatedTo: 'contacts',
      },
      errors: [],
      type: 'email',
      name: 'email',
      rules: {
        title: 'Email field',
        email: true,
        required: true,
      }
    },
    company: {
      label: 'Company',
      placeholder: 'Fill-in this field.',
      system: {
        component: Input,
        name: 'company',
        relatedTo: 'contacts',
      },
      value: '',
      errors: [],
      type: 'text',
      name: 'company',
      rules: {
        title: 'Company field',
      }
    },
    companyAddress: {
      label: 'Company Address',
      placeholder: 'Fill-in this field.',
      system: {
        component: Input,
        name: 'address',
        relatedTo: 'contacts',
      },
      value: '',
      errors: [],
      type: 'text',
      name: 'companyAddress',
      rules: {
        title: 'Company Address field',
      }
    },
    phone: {
      label: 'Phone',
      placeholder: 'Fill-in this field.',
      system: {
        component: Input,
        name: 'phone',
        relatedTo: 'contacts',
      },
      value: '',
      errors: [],
      type: 'text',
      name: 'phone',
      rules: {
        title: 'Phone field',
      }
    },
    fax: {
      label: 'Cell',
      placeholder: 'Fill-in this field.',
      system: {
        component: Input,
        name: 'fax',
        relatedTo: 'contacts',
      },
      value: '',
      errors: [],
      type: 'text',
      name: 'fax',
      rules: {
        title: 'Cell field',
      }
    },
};

export const basic = {
  username: {
    label: 'Name',
    placeholder: 'Fill-in this field.',
    system: {
      name: 'name',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'name',
    rules: {
      title: 'User name field',
      required: true,
    }
  },
  terms: {
    label: 'Terms',
    value: '',
    errors: [],
    name: 'terms',
    system: {
      name: 'term',
    },
    rules: {
      title: 'Terms field',
      required: true,
    },
    options: ['COD', 'Net 30', 'Net 45', 'Net 60', 'Net 75', 'Net 90']
  },
  taxing: {
    label: 'Taxing',
    value: '',
    errors: [],
    name: 'taxing',
    system: {
      name: 'taxing',
    },
    rules: {
      title: 'Taxing field',
      required: true,
    },
    options: ["Taxable", "Non-taxable"]
  },
  details: [],
  contacts: [],
  remove_project_detail_ids: [],
};



// WEBPACK FOOTER //
// ./src/containers/CustomerAdd/fields.js